import { clear, get, set, storagableKeys } from "./storage";
import { AmplifyConfig, URLConfig } from "../types/AmplifyConfig";
import { Region } from "../types/Region";
import { decodeBase64 } from "./utils";
import { CupixWorksDomain } from "./legacy_utils";

const parseString = (param: string | null) => {
  if (!param) return "";

  switch (param) {
    case "true":
      return true;
    case "false":
      return false;
    case "null":
      return undefined;
    case "undefined":
      return undefined;
    default:
      return decodeURI(param);
  }
};

// NOTE: currently, this only be used for OAuth flow that absent of cupixworks_api_endpoint
const buildDefaultConfig = (queryString: any): AmplifyConfig => {
  const config = {
    region: (queryString.region || "us").toLowerCase() as Region,
    regions: [],
  } as AmplifyConfig;
  config[config.region] = {
    clientId: queryString.client_id,
    redirectUri: queryString.redirect_uri,
    cupixworksApiEndpoint: CupixWorksDomain(queryString.team_domain, config.region),
  };

  return config;
};

export const parseQueryString = (searchParams: URLSearchParams, defaultQueryString: any) => {
  const params = {...defaultQueryString};
  
  // parse string into object
  Object.keys(params).forEach(key => {
    params[key] = parseString(params[key]);
  });

  for (const key of searchParams.keys()) {
    if (searchParams.get(key)) {
      params[key] = parseString(searchParams.get(key));
    } else {
      params[key] = defaultQueryString[key] || "";
      params[key] = decodeURI(params[key]);
    }
  }

  if (params["clear"] ?? false) {
    clear();
  }

  storagableKeys.forEach(key => {
    if (!params[key] || params[key] === "") {
      params[key] = get(key);
    } else {
      set(key, params[key]);
    }
  });

  return params;
}

export const parseAmplifyConfig = (queryString: any): AmplifyConfig => {
  const config = queryString.config;

  try {
    const decoded = decodeBase64(config);
    const decodedConfig = JSON.parse(decoded) as URLConfig[];
    const amplifyConfig = {
      region: decodedConfig[0]?.region_display?.toLowerCase() ?? "",
      regions: [],
    } as AmplifyConfig;

    decodedConfig.forEach((config: URLConfig) => {
      const region = config.region_display.toLowerCase() as Region;
      amplifyConfig[region] = {
        clientId: config.client_id,
        redirectUri: config.redirect_uri ?? "",
        cupixworksApiEndpoint: config.cupixworks_api_endpoint,
      };

      amplifyConfig.regions.push(region);
      if (config.selected) {
        amplifyConfig.region = region;
      }
    });

    if (
      queryString.region &&
      queryString.region.length > 0 &&
      amplifyConfig.regions.includes(queryString.region)
    ) {
      amplifyConfig.region = queryString.region;
    }

    set("redirect_uri", amplifyConfig[amplifyConfig.region]?.redirectUri || "");
    set("region", amplifyConfig.region || "");
    return amplifyConfig;
  } catch (e) {
    if (queryString.oauth_flow) {
      return buildDefaultConfig(queryString);
    }

    if (!config) {
      console.log('config is not provided, returning empty config');
    } else {
      console.warn('Failed to decode base64 clients config: ', config, e);
    }
    return {
      region: "" as Region,
      regions: [],
    }
  };
}